"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useStatefulRefValue;
var _react = require("react");
/**
 * Store ref value in state for reference
 *
 * @param {React.Ref} ref ref used to fetch current value
 * @param {Object} initialState initial state for ref value
 * @returns {Array<Object,React.EffectCallback>} current state and ref callback
 */
function useStatefulRefValue(ref, initialState) {
  const [state, setState] = (0, _react.useState)(initialState);
  const callbackRef = (0, _react.useCallback)(refValue => {
    ref.current = refValue;
    setState(refValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return [state, callbackRef];
}